import { call } from '../../utils/serviceUtils';
import {
  PROCESS_TEMPLATE_GET,
  PROCESS_TEMPLATE
  } from '../../config/paths';


export function getProcessTemplates() {
  return call.get(PROCESS_TEMPLATE_GET,
    {

    });
}

export function deleteProcessTemplateById(id) {
  return call.delete(PROCESS_TEMPLATE+'/'+id,
  {
    
  });
}

export function createProcessTemplate(data) {
  return call.post(PROCESS_TEMPLATE,data);
}

export function updateProcessTemplate(id,data) {
  return call.put(PROCESS_TEMPLATE+'/'+id,data);
}